import type { SingPitchId } from './clingCantaConfig';

/** Grabaciones en `/public/junior-assets/sounds/`. */
const PITCH_SAMPLE: Partial<Record<SingPitchId, string>> = {
  Do4: '/junior-assets/sounds/do.wav',
  Re4: '/junior-assets/sounds/re.wav',
  Mi4: '/junior-assets/sounds/mi.wav',
  Fa4: '/junior-assets/sounds/Fa.wav',
  Sol4: '/junior-assets/sounds/Sol.wav',
  La4: '/junior-assets/sounds/La.wav',
  Si4: '/junior-assets/sounds/Si.wav',
  Do5: '/junior-assets/sounds/Do7.wav',
  Si3: '/junior-assets/sounds/Si.wav',
  La3: '/junior-assets/sounds/La5.wav',
};

const cache = new Map<string, HTMLAudioElement>();

function getAudio(url: string): HTMLAudioElement {
  let el = cache.get(url);
  if (!el) {
    el = new Audio(url);
    el.preload = 'auto';
    cache.set(url, el);
  }
  return el;
}

export function preloadClingNoteSamples(pitches: SingPitchId[]): void {
  for (const pitchId of pitches) {
    const url = PITCH_SAMPLE[pitchId];
    if (url) getAudio(url);
  }
}

export function playSingPitchSample(pitchId: SingPitchId, volume = 0.88): void {
  const url = PITCH_SAMPLE[pitchId];
  if (!url) return;
  const clip = getAudio(url).cloneNode() as HTMLAudioElement;
  clip.volume = volume;
  void clip.play().catch(() => {});
}
